import { showError } from "./toast";

/**
 * Validate form fields based on an array of rules.
 * Each rule is { value, message, type? }.
 *
 * type = "required" (default) — checks truthy + non-empty string
 * type = "minLength" — checks array length > 0
 *
 * @param {Array} rules - Array of { value, message, type? }
 * @returns {boolean} true if all fields valid, false otherwise
 */
export function validateFields(rules) {
  for (const rule of rules) {
    const { value, message, type = "required", show = true } = rule;

    // Skip rule if show is explicitly false
    if (show === false) continue;

    if (type === "required") {
      if (!value || (typeof value === "string" && !value.trim())) {
        showError(message);
        return false;
      }
    }

    if (type === "minLength") {
      if (!Array.isArray(value) || value.length === 0) {
        showError(message);
        return false;
      }
    }
  }

  return true;
}
